import React from 'react';

export interface QuickMathStepView {
  accumulator: number;
  op: '+' | '-';
  operand: number;
}

interface QuickMathStepDisplayProps {
  step: QuickMathStepView | null;
  /** When no step (finished chain) */
  emptyLabel?: string;
}

/**
 * Option A: single binary step only (accumulator, operator, next number).
 */
export const QuickMathStepDisplay: React.FC<QuickMathStepDisplayProps> = ({
  step,
  emptyLabel = '—',
}) => {
  if (!step) {
    return (
      <div className="quick-math-step" aria-live="polite">
        <span className="quick-math-step__acc">{emptyLabel}</span>
      </div>
    );
  }
  return (
    <div className="quick-math-step" aria-live="polite">
      <span className="quick-math-step__acc">{step.accumulator}</span>
      <span className="quick-math-step__op">{step.op}</span>
      <span className="quick-math-step__operand">{step.operand}</span>
    </div>
  );
};
